import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getDeliveryProducts, getOrderMilestones } from 'features/order-tracker/store/selectors';
import { DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';

import { Milestone } from './components';

import styles from './styles.module.scss';

export function MilestonesColumn() {
  const orderMilestones = useSelector(getOrderMilestones);
  const { smartHubProduct, isHybridConnectAvailable } = useSelector(getDeliveryProducts);

  const smartHubDeliveryInfo = useMemo(() => {
    const deliveredItem = orderMilestones
      .filter((item) => item.delivery)
      .find((item) => item.status === DELIVERY_STATUSES.Delivered);

    return { isOrderDeliveriesInProgress: !deliveredItem, smartHubProduct, isHybridConnectAvailable };
  }, [orderMilestones, smartHubProduct, isHybridConnectAvailable]);
  return (
    <div className={styles.milestoneContainer}>
      <h3 className={styles.title}>Order milestones</h3>
      <div className={styles.milestoneContent}>
        {orderMilestones.map((milestone) => (
          <Milestone
            key={milestone.renderKey ?? milestone.id}
            smartHubDeliveryInfo={smartHubDeliveryInfo}
            {...milestone}
          />
        ))}
      </div>
    </div>
  );
}
